export default __webpack_public_path__ + "images/na-e241f81665d5aa3bcd027395adb6eb1a.svg";